import React from 'react'
import i18n from '../../i18n';
import AutoComplete from './AutoComplete'

class InputSearch extends React.PureComponent {
  constructor(props) {
    super(props)

    this.handleChanged = this.handleChanged.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleClear = this.handleClear.bind(this)

    this.state = {
      text: props.value,
      invalid_value: false
    }
  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, text: props.value }
  }

  handleChanged(newText) {
    this.setState({
      text: newText
    })
    this.props.onTextChange(newText)
  }

  handleSearch() {
    if(this.validate())
      this.props.onSubmit(this.state.text.trim())
  }

  handleClear() {
    this.setState({text: ''})
    this.props.onSubmit('')
  }

  validate() {
    const { text } = this.state

    if(text !== '' && text.trim() === ''){
      this.setState({invalid_value: true})
      return false
    } else {
      this.setState({invalid_value: false})
      return true
    }
  }

  render() {
    return (
      <div className="input-search">
        <div className="input-group">
          <AutoComplete {...this.props}
            isListAllWhenTextEmpty={true}
            placeholder={this.props.placeholder} 
            onTextChange={this.handleChanged} 
            onPressEnter={this.handleSearch} 
            onClear={this.handleClear}
          />
        </div>
        { this.state.invalid_value && <div className='error'>{i18n.t('bank.messages.have_incorrect_word')}</div> }
      </div>
    );
  }
}

export default InputSearch
